export default __webpack_public_path__ + "static/media/icon_attachment.6f6361e6.svg";